import { IArtwork } from "../../interfaces/IArtwork";
import { MArtwork } from "../../models/MArtwork";
import { User } from "../../models/User";
import * as artworkAPIUtil from "../../util/artwork/artworkAPIUtil";
import { IArtFilters } from "../state/artworksState";
import * as catalogueAPIUtil from "../../util/catalogue/catalogueAPIUtil";
export const RECEIVE_ARTWORK_LIST = "[Artwork] RECEIVE_ARTWORK_LIST";
export const IS_LOADING = "[Artwork] IS_LOADING";
export const CLEAR_FILTERS = "[Artwork] CLEAR_FILTERS";
export const FETCH_ERROR = "[Catalogues List] FETCH_ERROR";
export const UPDATE_FILTERS = "[Artwork] UPDATE_FILTERS";
export const RECEIVE_ART_DECORATORS_VENDORS_LIST = "[Artwork decorators type] RECEIVE_ART_DECORATORS_VENDORS_LIST";
export const RECEIVE_ART_DECORATION_TYPE = "[Artwork decoration type] RECEIVE_ART_DECORATION_TYPE";
export const RECEIVE_ART_DECORATORS_TYPE_LIST = "[Artwork decoration type] RECEIVE_ART_DECORATORS_TYPE_LIST";

export const receiveArtworks = (artworks: { [key: string]: IArtwork }, count, meta) => ({
  type: RECEIVE_ARTWORK_LIST,
  artworks,
  count,
  meta
});
export const sendFetchError = () => ({
  type: FETCH_ERROR
});
export const isLoading = (loading: boolean) => ({
  type: IS_LOADING,
  loading
});

export const clearFilters = (currentUser: User) => ({
  type: CLEAR_FILTERS,
  currentUser
});

export const receiveFilterUpdate = (filter: { [key: string]: any }) => ({
  type: UPDATE_FILTERS,
  payload: filter
});

export const fetchArtworkList = (
  limit: number = 50,
  offset: number = 0,
  order: string = "",
  orient: string = "asc",
  filters: IArtFilters
) => (dispatch) => (
  artworkAPIUtil.fetchArtworks(limit, offset, order, orient, filters)
    .then(res => {
      const artworks = {};
      res.data.data.forEach(individualArtwork => {
        const modeledArtwork = new MArtwork(individualArtwork);
        artworks[modeledArtwork.id] = modeledArtwork;
      });
      dispatch(receiveArtworks(artworks, res.data.meta.page_count, res.data.meta));
    }).catch(error => {
      console.log("Error in fetching Artwork", error);
      dispatch(isLoading(false));
    })
)
export const receiveDecoratorVendors = (types) => ({
  type: RECEIVE_ART_DECORATORS_VENDORS_LIST,
  payload: types,
});
export const getDecoratorVendors = () => dispatch => catalogueAPIUtil.getDecoratorVendors()
  .then(res => {

    dispatch(isLoading(false));
    dispatch(receiveDecoratorVendors(res.data))
  }).catch(error => {
    dispatch(isLoading(false));
  });
export const receiveDecorationType = (types: []) => ({
  type: RECEIVE_ART_DECORATION_TYPE,
  payload: types,
});
export const fetchDecorationTypes = () => dispatch => catalogueAPIUtil.fetchDecorationTypes()
  .then(res => {
    dispatch(receiveDecorationType(res.data))
  }).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
  });
export const receiveDecoratorTypes = (types) => ({
  type: RECEIVE_ART_DECORATORS_TYPE_LIST,
  payload: types,
});
export const getDecoratorTypes = () => dispatch => catalogueAPIUtil.getDecoratorTypes()
  .then(res => {
    dispatch(isLoading(false));
    dispatch(receiveDecoratorTypes(res.data))
  }).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
  });
